import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import Home from '@screens/home/home';
import Profile from '@screens/profile/profile';
import PlayerDetails from '@screens/players/player.details';
import NotFound from '@screens/not.found/not.found';
import { useMenuOptions } from '@data/menu.options.data';
import TourneyPoints from '@screens/tourneys/tourney.points';
import SeasonMissions from '@screens/season/season.missions';
import RouteWrapper from './route.wrapper';

const Routes = () => {
  const { url } = useRouteMatch();
  const menuOptions = useMenuOptions();

  return (
    <Switch>
      <RouteWrapper path={`${url}/profile`} component={Profile} pageTitle='Profile' />
      <RouteWrapper path={`${url}/player/:pid`} component={PlayerDetails} pageTitle='Player Details' />
      <RouteWrapper path={`${url}/tourneys/:tourneyId`} component={TourneyPoints} pageTitle='Tourney Points' />
      <RouteWrapper path={`${url}/seasons/:seasonId`} component={SeasonMissions} pageTitle='Season Missions' />

      {menuOptions.map((o) => (
        <RouteWrapper key={o.id} path={`${url}${o.routePath || o.url}`} component={o.routeComponent} pageTitle={o.title} />
      ))}

      <RouteWrapper path={`${url}/`} component={Home} pageTitle='Home' exact />
      <RouteWrapper path={`${url}*`} component={NotFound} />
    </Switch>
  );
};

export default Routes;
